import { Component, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {MatIconRegistry} from "@angular/material/icon";

@Component({
    selector: 'ois-icon-wrapper',
    templateUrl: './icon-wrapper.component.html',
    styleUrls: ['./icon-wrapper.component.scss']
})
export class IconWrapperComponent implements OnInit {
    @Input()
    icon: string;
    @Output()
    iconName: string;

  constructor(private mdIconRegistry: MatIconRegistry, private domSanitazier: DomSanitizer) {
    }
    ngOnInit() {
        // TODO: Configure svg bundling.
        this.mdIconRegistry.addSvgIcon(this.icon, this.domSanitazier.bypassSecurityTrustResourceUrl(this.icon));
        this.iconName = this.icon;
    }
}
